import React from 'react';
import classNames from 'classnames';
import styles from './TextField.module.scss';

export enum TextFieldTypes {
  Text = 'text',
  Password = 'password',
}

type PropsType = {
  name: string;
  type?: TextFieldTypes;
  value?: string;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  touched?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const TextField = (props: PropsType) => {
  return (
    <>
      <div className={styles.wrapper}>
        <input
          type={props.type || 'text'}
          name={props.name}
          value={props.value}
          className={classNames(styles.input, props.className, props.disabled && styles.disabled)}
          placeholder={props.placeholder}
          disabled={props.disabled}
          onChange={props.onChange}
          onBlur={props.onBlur}
          aria-label={props.name}
        />

        {props.touched && props.error && (
          <div className={styles.errorField}>{props.error && <div>{props.error}</div>}</div>
        )}
      </div>
    </>
  );
};

export default TextField;
